export default __webpack_public_path__ + "static/media/arrows-to-line.e320d100.svg";